import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { siteData } from "../mock";

const Ideas = () => {
  return (
    <div className="bg-[#05070d]">
      <section className="relative pt-36 pb-20 bg-gradient-to-br from-[#05070d] via-[#0b1220] to-[#05070d]">
        <div className="absolute inset-0 dark-grid" />
        <div className="relative max-w-7xl mx-auto px-5 md:px-8">
          <span className="text-xs font-semibold tracking-[0.25em] text-blue-400">IDEAS</span>
          <h1 className="mt-3 text-4xl md:text-5xl font-bold tracking-tight text-white max-w-3xl">
            {siteData.ideas.title}
          </h1>
          <p className="mt-5 text-lg text-white/75 max-w-2xl leading-relaxed">
            {siteData.ideas.lead}
          </p>
        </div>
      </section>

      <section className="py-20 bg-[#05070d]">
        <div className="max-w-3xl mx-auto px-5 md:px-8 space-y-6 text-white/80 leading-relaxed text-lg">
          {siteData.ideas.paragraphs.map((p, i) => (<p key={i}>{p}</p>))}
          <div className="pt-4">
            <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-blue-600 text-white font-semibold hover:bg-blue-500 transition-colors">
              Talk to us <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Ideas;
